import {FormInputComponent} from './formInput/form-input.component';
import {DateComponent} from './date/date.component';
import {BrowserWarningComponent} from './browserWarning/browserWarning.component';
import {LabelTooltipComponent} from './labelTooltip/labelTooltip.component';
import {SpinningContainerComponent} from './spinningContainer/spinningContainer.component';
import {InfotextPermanentComponent} from './infotext-permanent/infotext-permanent.component';
import {InfoTextTooltipCollapsableComponent} from './info-text-tooltip-collapsable/info-text-tooltip-collapsable.component';
import {InstanaComponent} from './instana/instana.component';
import {TertiaryButtonComponent} from './button/tertiary-button/tertiary-button.component';
import {NotificationComponent} from './notification/notification/notification.component';
import {NotificationItemComponent} from './notification/notification-item/notification-item.component';

const DIRECTIVES = [];

export const ALL_COMPONENTS = [
  FormInputComponent,
  DateComponent,
  BrowserWarningComponent,
  LabelTooltipComponent,
  SpinningContainerComponent,
  InfotextPermanentComponent,
  InfoTextTooltipCollapsableComponent,
  InstanaComponent,
  TertiaryButtonComponent,
  NotificationComponent,
  NotificationItemComponent,
  ...DIRECTIVES,
];
